import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AccountFormV2Component } from './account-form-v2/account-form-v2';
import { ShippingFormV2Component } from './shipping-form-v2/shipping-form-v2';
import { PaymentFormV2Component } from './payment-form-v2/payment-form-v2';
import { SharedModule } from 'src/app/shared/shared.module';
import { HeaderWithMenuComponent } from 'src/app/components/header-with-menu/header-with-menu';

@NgModule({
  declarations: [
    AccountFormV2Component,
    ShippingFormV2Component,
    PaymentFormV2Component,
    HeaderWithMenuComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
  ],
  exports: [
    AccountFormV2Component,
    ShippingFormV2Component,
    PaymentFormV2Component,
    HeaderWithMenuComponent,
  ],
})
export class ComponentsModule {
}
